import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { SurveyForm } from '..'
import { SurveySuccess } from '../SurveySuccess/SurveySuccess'

export const SurveyBootstrap = () => (
  <Switch>
    <Route
      path="/:establishmentId/surveys/:surveyId/:customerId/:customerToken/:invitationUuid?"
      component={SurveyForm}
    />
    <Route path="/:establishmentId/surveys/success" component={SurveySuccess} />
  </Switch>
)
